// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__290hT","path":"style_path__2cloj","arrow":"style_arrow__14jdN"};